import { Tag } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

export class TagController extends BaseHttpController {
  static readonly ENDPOINT: string = 'tag';

  constructor() {
    super(TagController.ENDPOINT, { canIncludeSubDomains: true });
  }

  async findAll(): Promise<Tag[]> {
    const response = await this.http.get<Tag[]>('');
    return response.data;
  }

  async delete(tag: Tag): Promise<void> {
    await this.http.delete('', { data: tag });
  }
}
